export const getCookie = (cname) => {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const initUserInfo = () => {
  let userInfo = {};
  const sharedInfoCookie = getCookie("SWY_SHARED_SESSION_INFO");
  let kmsiCookie = getCookie("SAFEWAY_KMSI");
  const sharedSessionInfo = sharedInfoCookie
    ? JSON.parse(sharedInfoCookie)
    : "";

  if (sharedSessionInfo && sharedSessionInfo.info) {
    const userCookieCommon = sharedSessionInfo.info.COMMON;
    const userCookieShop = sharedSessionInfo.info.SHOP;

    if (userCookieCommon) {
      userInfo.userType =
        userCookieShop && userCookieShop.userType
          ? userCookieShop.userType
          : userCookieCommon.userType;
      userInfo.houseHoldId = userCookieCommon.houseId || "ID not found";
      userInfo.clubCardNumber = userCookieCommon.clubCard || "ID not found";

      // loginStatus
      switch (userInfo.userType) {
        case "A":
        case "G":
          userInfo.loginStatus = "guest";
          break;
        case "R":
        case "C":
        case "D":
        case "M":
          userInfo.loginStatus = "registered";
          break;
        default:
          break;
      }
      if (kmsiCookie && userInfo.loginStatus) {
        kmsiCookie = kmsiCookie.toLowerCase();
        if (kmsiCookie == "true") {
          userInfo.loginStatus += "|kmsi";
        } else if (kmsiCookie == "false") {
          userInfo.loginStatus += "|nonkmsi";
        }
      }

      // deliveryPreference
      switch (userCookieCommon.preference.toLowerCase()) {
        case "dug":
          userInfo.deliveryPreference = "dug";
          break;
        case "delivery":
          userInfo.deliveryPreference = "delivery";
          break;
        case "j4u":
          userInfo.deliveryPreference = "inStore";
          break;
        default:
          break;
      }

      if (userCookieShop) {
        userInfo.shopStoreId = userCookieShop.storeId;
        userInfo.shopZipCode = userCookieShop.zipcode;
      }
    }

    // orderStatus and  customerStatus
    if (userInfo.userType == "R" || userInfo.userType == "C") {
      userInfo.orderStatus = localStorage.getItem("abOrderCount") || "";
      if (userInfo.orderStatus === "0") {
        userInfo.customerStatus = "first";
      } else if (userInfo.orderStatus > 0) {
        userInfo.customerStatus = "returning";
      }
    }
  }

  return userInfo;
};

export const setCookie = (name, value) =>
  (document.cookie = `${name}=${value}; path=/`);
